import { makeStyles } from "makeStyles";
import { Box, Table, TableBody, TableCell, TableRow } from "@mui/material";
import { permissionsTableStyles } from "./styles";

const useStyles = makeStyles()((theme) => ({
  ...permissionsTableStyles(theme),
  reallyTightCell: {
    padding: "1px"
  }
}));

interface Props {
  values?: string[];
}

const SingleValues: React.FunctionComponent<Props> = (props) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.childTableContainer}>
      <Table size="small" className={classes.tinyTable}>
        <TableBody>
          {props.values?.map((value) => (
            <TableRow key={value}>
              <TableCell>{value}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default SingleValues;
